import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { injectable } from "tsyringe";
import { AuthenticationRequestEntity } from "../entities/AuthenticationRequestEntity";
import { AuthenticationResponseEntity } from "../entities/AuthenticationResponseEntity";
import { IAuthenticationRepository } from "../repositories/IAuthenticationRepository";
import { AuthenticationInjection } from "features/login/di/AuthenticationInjection";

@injectable()
export class AuthenticationUseCase {
  private authenRepo: IAuthenticationRepository;

  constructor() {
    this.authenRepo = AuthenticationInjection.getAuthenticationRepo();
  }

  async login(
    body: AuthenticationRequestEntity,
  ): Promise<BaseApiResponseModel<AuthenticationResponseEntity>> {
    localStorage.setItem("isSavedForNextLogin", `${body?.isSavedForNextLogin}`);
    delete body?.isSavedForNextLogin;
    const updatedBody = new AuthenticationRequestEntity().switchMode(
      body,
      "login",
    );
    return await this.authenRepo.login(updatedBody);
  }

  async signUp(
    body: AuthenticationRequestEntity,
  ): Promise<BaseApiResponseModel<AuthenticationResponseEntity>> {
    const updatedBody = new AuthenticationRequestEntity().switchMode(
      body,
      "signUp",
    );
    return await this.authenRepo.signUp(updatedBody);
  }
}
